import { Report1912 } from "../../../components/borrowSystem/Report/Report1912";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1912Container() {
  const titleName =
    " สรุปข้อมูลการอนุมัติให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน (จำแนกตามหน่วยงานที่ให้กู้ยืมเงิน)";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1912 />
      <Footer />
    </div>
  );
}
